import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationRoomSizeSmall: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = false, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_5248_12053"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_5248_12053)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <rect
          width="147.887"
          height="101.408"
          x="130.113"
          y="79.789"
          stroke={colors.primary[500]}
          strokeDasharray="2 10"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          rx="4"
        ></rect>
        <path
          stroke={colors.primary[500]}
          strokeDasharray="2 10"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M210.395 121.338V83.789a4 4 0 00-4-4h-72.282a4 4 0 00-4 4v93.408a4 4 0 004 4h72.282a4 4 0 004-4v-33.323"
        ></path>
        <path
          fill={colors.primary[100]}
          d="M78 83.79a4 4 0 014-4H141.606a4 4 0 014 4v93.407a4 4 0 01-4 4H82a4 4 0 01-4-4V83.789z"
        ></path>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M103.352 79.79H82a4 4 0 00-4 4v93.407a4 4 0 004 4h59.606a4 4 0 004-4V83.789a4 4 0 00-4-4h-17.127M103.352 79.789L118.14 65"
        ></path>
        <path
          stroke={colors.primary[500]}
          strokeDasharray="2 8"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M210.395 121.338L228 138.944"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export default IllustrationRoomSizeSmall;
